import actions from '@ehi/global-marketing-interface/lib/actions';
import { uiOneWayRentalPath } from 'paths/uiState';

/**
 * action to update state ui based on whether the current reservation is one-way
 * @param {boolean} isOneWay - whether or not the reservation is a one-way
 */
export const setIsGmiUIOneWayRental = (isOneWay) => (dispatch) =>
  dispatch(actions.setGmiState(uiOneWayRentalPath, isOneWay));
